import {Text} from '@rdcomponents/text/text';
import {Popover} from 'antd';

import {YandexCompanyStatusEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';
import {classNames} from '../../../../../../../util/css';

import wgisActualizationMarker from './images/wgis-actualization-marker.svg';
import {
    wgisActualizationStatusMarkPopoverContentLangKey,
    wgisActualizationStatusMarkPopoverTitleLangKey,
} from './wgis-actualization-status-mark-helper';
import * as styles from './wgis-actualization-status-mark.scss';

type PropsType = {
    status?: YandexCompanyStatusEnum | null;
};

export function WgisActualizationStatusMark(props: PropsType): JSX.Element | null {
    const {status} = props;

    if (!status) {
        return null;
    }

    return (
        <Popover
            className={styles.WgisActualizationStatusMark_popoverContent}
            content={
                <div className={styles.WgisActualizationStatusMark_popoverContent}>
                    <Text block stringKey={wgisActualizationStatusMarkPopoverContentLangKey[status]} />
                </div>
            }
            title={
                <Text
                    block
                    bolder
                    className={styles.WgisActualizationStatusMark_popoverTitle}
                    stringKey={wgisActualizationStatusMarkPopoverTitleLangKey[status]}
                />
            }
        >
            <div
                className={classNames(styles.WgisActualizationStatusMark, {
                    [styles.WgisActualizationStatusMark__actualized]: status === YandexCompanyStatusEnum.Actualized,
                    [styles.WgisActualizationStatusMark__notActualized]:
                        status === YandexCompanyStatusEnum.NotActualized,
                    [styles.WgisActualizationStatusMark__needActualize]:
                        status === YandexCompanyStatusEnum.NeedActualize,
                })}
            >
                <img
                    alt="marker"
                    className={classNames(styles.WgisActualizationStatusMark__marker, {
                        [styles.WgisActualizationStatusMark__marker_notActualized]:
                            status === YandexCompanyStatusEnum.NotActualized,
                    })}
                    src={wgisActualizationMarker}
                />
            </div>
        </Popover>
    );
}
